import React from 'react';
import NftDetailContainer from './NftDetailsContainer';

export default function NftDetailsComponent(props) {
  return (
    <main className="main center_container">
      <div className="container">
        <NftDetailContainer
          data={props.data}
          isMultiple={props.isMultiple}
          musicData={props.musicData}
          bsvRate={props.bsvRate}
          isAdmin={props.isAdmin}
        />
      </div>
    </main>
  );
}
